import { queryKeys } from "@/constants/queryKeys";
import { useCustomerScopedQuery } from "@/hooks/useCustomerScopedQuery";
import { services } from "@/services/registry";
export const useAuditLogs = (startDate, endDate, apiKeyId, limit, nextToken, enabled = true)=>{
    return useCustomerScopedQuery({
        queryKey: queryKeys.auditLogs.list(startDate, endDate, apiKeyId, undefined, limit, nextToken),
        queryFn: ({ customerId })=>services.auditLogsService.getAuditLogs(startDate, endDate, apiKeyId, customerId, limit, nextToken),
        enabled,
        staleTime: 1 * 60 * 1000
    });
};
